import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { ThemeDetails } from './themeDetails.type';
import { getThemeApi } from './themeDetails.api';

const initialState: ThemeDetails = {
	loading: false,
	theme: {},
	selectedTheme: {},
};

const getTheme = createAsyncThunk(
	'themeDetails/getTheme',
	async (
		body: { pk: string; sk: string },
		{ rejectWithValue, getState }: any
	) => {
		try {
			const response = await getThemeApi(body.pk, body.sk);
			return response;
		} catch (e) {
			return rejectWithValue(e);
		}
	}
);

const themeDetailsSlice = createSlice({
	name: 'themeDetails',
	initialState: initialState,
	reducers: {
		setThemeDetails: (state, action) => {
			return { ...state, ...action.payload };
		},
		reset: () => initialState,
	},

	extraReducers: (builder) => {
		builder.addCase(getTheme.pending, (state, action) => {
			state.loading = true;
		});
		builder.addCase(getTheme.fulfilled, (state, action) => {
			state.loading = false;
			state.theme = action.payload?.data;
		});
		builder.addCase(getTheme.rejected, (state, action) => {
			state.loading = false;
		});
	},
});

export const themeDetailsReducer = themeDetailsSlice.reducer;

export const themeDetailsActions = {
	...themeDetailsSlice.actions,
	getTheme,
};
